module.exports = __webpack_public_path__ + "media/images/web/home/index/cultural-7550fe35022f3ca441e13e68fec7f9fb.webp";